import React, { RefObject } from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { BenefitPopUpRef } from "./types";
import ClaimProfilePopUpWrapper from "./ClaimProfilePopUpWrapper";

export function init(model: Readonly<LSCommon.Service.LSWebUI.Models.XPP.XppLandingPageJsViewModel>, ref?: RefObject<BenefitPopUpRef>) {
   render(
      <Provider store={LSStore.instance}>
         <ClaimProfilePopUpWrapper ref={ref} venueId={model.VenueId} initialOpen={model.IsClaimable == LSCommon.Service.LSWebUI.Models.XPP.Claimable.ClaimableWithValidSecret} />
      </Provider>,
      document.body.appendChild(document.createElement("div"))
   );
}
